import { HugeiconsIcon } from "@hugeicons/react";
import { Search01Icon } from "@hugeicons-pro/core-stroke-rounded";
import {
  InputGroup,
  InputGroupAddon,
  InputGroupButton,
  InputGroupInput,
} from "@workspace/frontend-ui";
import type { ChangeEvent, FC, RefObject } from "react";
import type { ProviderFragment, SelectedProvider } from "../../types";
import ProviderDropdown from "./ProviderDropdown";
import SearchModalCloseButton from "./SearchModalCloseButton";
import SurpriseMeButton from "./SurpriseMeButton";

type Props = {
  search: string;
  onSearchChange: (e: ChangeEvent<HTMLInputElement>) => void;
  onSearchBlur: () => void;
  onClearSearch: () => void;
  searchPlaceholder: string;
  clearSearchLabel: string;
  showSurpriseMe: boolean;
  surpriseMeLabel: string;
  onSurpriseMe?: () => void;
  isTopScrolled: boolean;
  inputRef: RefObject<HTMLInputElement | null>;
  toggleProvider: (provider: SelectedProvider) => void;
  enabledProviders?: SelectedProvider[];
  allProviders?: ProviderFragment[];
  closeLabel: string;
};

const SearchHeaderBar: FC<Props> = ({
  search,
  onSearchChange,
  onSearchBlur,
  onClearSearch,
  searchPlaceholder,
  clearSearchLabel,
  showSurpriseMe,
  surpriseMeLabel,
  onSurpriseMe,
  isTopScrolled,
  inputRef,
  toggleProvider,
  enabledProviders,
  allProviders,
  closeLabel,
}) => (
  <div className="flex items-center gap-2 flex-wrap">
    <InputGroup className="h-11 flex-1 order-1">
      {!search && (
        <InputGroupAddon align="inline-start">
          <HugeiconsIcon icon={Search01Icon} />
        </InputGroupAddon>
      )}
      <InputGroupInput
        placeholder={searchPlaceholder}
        ref={inputRef}
        value={search}
        onChange={onSearchChange}
        onBlur={onSearchBlur}
        className="h-10 md:h-11!"
        data-testid="search-overlay-input"
      />
      {search && (
        <InputGroupAddon align="inline-end">
          <InputGroupButton
            onClick={onClearSearch}
            variant="link"
            className="text-foreground"
          >
            {clearSearchLabel}
          </InputGroupButton>
        </InputGroupAddon>
      )}
      {showSurpriseMe && (
        <InputGroupAddon align="inline-end">
          <SurpriseMeButton
            label={surpriseMeLabel}
            onClick={onSurpriseMe}
            isHidden={!isTopScrolled}
          />
        </InputGroupAddon>
      )}
    </InputGroup>
    <div className="order-3 w-full md:order-2 md:w-auto">
      <ProviderDropdown
        toggleProvider={toggleProvider}
        enabledProviders={enabledProviders}
        allProviders={allProviders}
      />
    </div>
    <SearchModalCloseButton label={closeLabel} />
  </div>
);

export default SearchHeaderBar;
